<template>
  <div class="h-full flex items-center">
    <div class="bg-white text-gray-800 text-center px-4 py-2 text-brand-green container max-w-md mx-auto text-center">
      <h2 class="mb-10 text-3xl font-heading">Start your 7 day free trial.</h2>
      <h2 class="mb-10 font-bold">Login with Github to start your 7 day free trial.</h2>
      <div class="mb-10">You can cancel the trial at any point before the 7 days ends and you won’t be charged. We will even remind you 1 day before. </div>
      <button @click="login" class="bg-black p-3 w-full block text-white center rounded" href="/login">
        <GithubLogo class="inline-block githublogo mr-4 mt-0"/>
        <div class="inline-block ">Login with Github</div>
      </button>
    </div>
  </div>
</template>

<script>
import GithubLogo from '@/assets/images/github-logo.svg'
import ky from 'ky'

export default {
  name: 'Login',
  methods: {
    async login () {
      const data = await ky.get(process.env.VUE_APP_API + '/auth/github').json()
      window.location = data.redirectUrl
    }
  },
  components: {
    GithubLogo
  }
}

</script>

<style scoped lang="scss">
.githublogo{
  width: 41px;
  height: 40px;

}
</style>
